import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterString, sortArrayBy } from '@domain-group/javascript-utils'
import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'
import { RoleModel } from '@models/role'

const watchEntityKeys = ['roles']

interface OptionType {
  deps?: any[],
  filters?: { string: string },
  performHttpRequests?: boolean,
}

function useRoles(options?: OptionType) {
  const { deps = [], filters, performHttpRequests } = options || {}

  const { string } = filters || {}

  const {
    updatedEntities: { roles: rolesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingRoles } = useReduxAction(
    'roles',
    'loadRoles',
    { ...filters },
    [performHttpRequests, filters, ...deps],
    // @ts-expect-error
    { shouldPerformFn: ({ loading, loaded }: { loading: boolean, loaded: boolean }) => performHttpRequests && !loading && !loaded },
  )

  const roles: RoleModel[] = useSelector((reduxState: any) => reduxState.entities.roles)

  const filteredRoles = useMemo(() => {
    const filtered = Object.values(roles).filter((role) => {
      const { id, title } = role

      const idMatch = id.toString() === string
      const titleMatch = matchFilterString(title, string)
      const matchString = idMatch || titleMatch

      return matchString
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [rolesUpdatedAt, JSON.stringify(filters)])

  const hasFilteredRoles = !!filteredRoles.length

  return {
    filteredRoles,
    hasFilteredRoles,
    loading: loadingRoles,
    roles,
  }
}

export default useRoles
